// import firebase from "./firebase"; // Import the initialized Firebase app

// class FirebaseMessaging {
//   messaging = firebase.messaging();

//   async getToken() {
//     try {
//       const token = await this.messaging.getToken();
//       return token;
//     } catch (error) {
//       console.error("Error fetching Firebase token:", error);
//     }
//   }

//   async requestNotificationPermission() {
//     try {
//       await Notification.requestPermission();
//       const token = await this.getToken();
//       window.sessionStorage.setItem("fcm", token);
//       return token;
//     } catch (error) {
//       console.error("Error requesting permission:", error);
//     }
//   }

//   onMessage(callback) {
//     this.messaging.onMessage(callback);
//   }
// }

// export default new FirebaseMessaging();

import firebase from "./firebase";

class FirebaseMessaging {
  messaging = null;

  constructor() {
    try {
      if (
        typeof window !== "undefined" &&
        "serviceWorker" in navigator &&
        window.isSecureContext
      ) {
        this.messaging = firebase.messaging();
      }
    } catch (error) {
      console.error("Firebase Messaging initialization error:", error);
      this.messaging = null;
    }
  }

  async getToken() {
    try {
      if (!this.messaging) {
        console.warn("Firebase Messaging is not available.");
        return null;
      }

      const token = await this.messaging.getToken();

      return token;
    } catch (error) {
      console.error("Error fetching Firebase token:", error);
      return null;
    }
  }

  async requestNotificationPermission() {
    try {
      if (!this.messaging) {
        console.warn("Firebase Messaging is not available.");
        return null;
      }

      const permission = await Notification.requestPermission();

      if (permission !== "granted") {
        console.warn("Notification permission denied.");
        return null;
      }

      const token = await this.getToken();

      if (token) {
        window.sessionStorage.setItem("fcm", token);
      }

      return token;
    } catch (error) {
      console.error("Error requesting permission:", error);
      return null;
    }
  }

  onMessage(callback) {
    try {
      if (!this.messaging) {
        console.warn("Firebase Messaging is not available.");
        return;
      }

      this.messaging.onMessage(callback);
    } catch (error) {
      console.error("Firebase onMessage error:", error);
    }
  }
}

export default new FirebaseMessaging();